import React, { useContext } from 'react';
import { createContext } from 'react';

import { ShippingSimulatorProps } from '../@types/ShippingSimulatorProps';

interface SSP extends ShippingSimulatorProps {
	isOpen: boolean;
	toggleOpen: any;
}

export const ShippingSimulatorContext = createContext<SSP>({} as SSP);

ShippingSimulatorContext.displayName = 'ShippingSimulator';

const ShippingSimulatorProvider = (props: ShippingSimulatorProps) => {
	const [isOpen, setIsOpen] = React.useState(false);
	const toggleOpen = () => setIsOpen(!isOpen);

	return (
		<ShippingSimulatorContext.Provider value={{ ...props, isOpen, toggleOpen }}>
			{props.children}
		</ShippingSimulatorContext.Provider>
	);
};

export const useShippingSimulator = () => {
	const context = useContext(ShippingSimulatorContext);

	return context;
};

export default ShippingSimulatorProvider;
